import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';
import * as _ from 'underscore';

export class DrNamedQueryViewModel extends DrObject {

    model: Partial<DrNamedQuery>;

    constructor(objectType: DrObjectType, value?: Partial<DrNamedQuery>);
    constructor(objectType: DrObjectType, value?: Partial<DrNamedQuery>, regex?: SupportedRegExType, maxNameLength?: number, maxDescriptionLength?: number) {
        super(objectType);

        if (value) {
            this.model = value;
        }

        if (regex) {
            this.regex = regex;
        }

        if (maxNameLength) {
            this.maxNameLength = maxNameLength;
        }

        if (maxDescriptionLength) {
            this.maxDescriptionLength = maxDescriptionLength;
        }
    }

}

export class DrNamedQuery {
    name: string;
    description: string;
    query: string;
    annotationText: string;
    hasError?: boolean;
    isWarningInQueryColumn?: boolean;
    errorText?: string;
    hoverIcon?: boolean;

    constructor(value?: Partial<DrNamedQuery>) {
        if (value) {
            Object.assign(this, value);
        }
    }

    static removeEmptyQueries(namedQueries: Array<DrNamedQuery>): Array<DrNamedQuery> {
        const filteredNamedQueries = _.each(_.filter(namedQueries,
            function (item) { return !_.isEmpty(item.name) && !_.isEmpty(item.query); }),
            function (filteredItem) {
                filteredItem.name = filteredItem.name.replace(/\r?\n|\r/g, '');
                filteredItem.query = filteredItem.query.replace(/\r?\n|\r/g, '');
            });
        return filteredNamedQueries;
    }

    static removeEmptyNames(namedQueries: Array<DrNamedQuery>): Array<DrNamedQuery> {
        const filteredNamedQueries = _.each(_.filter(namedQueries,
            function (item) { return !_.isEmpty(item.name.trim()); }),
            function (filteredItem) {
                filteredItem.name = filteredItem.name.replace(/\r?\n|\r/g, '');
            });
        return filteredNamedQueries;
    }

    static removeStrictEmptyQueries(namedQueries: Array<DrNamedQuery>): Array<DrNamedQuery> {
        const filteredNamedQueries = _.each(_.filter(namedQueries,
            function (item) { return !_.isEmpty(item.query); }),
            function (filteredItem) {
                filteredItem.query = filteredItem.query.replace(/\r?\n|\r/g, '');
            });
        return filteredNamedQueries;
    }
}

